import { render, staticRenderFns } from "./CreateColumnForm.vue?vue&type=template&id=43d830f6&scoped=true&"
import script from "./CreateColumnForm.vue?vue&type=script&lang=js&"
export * from "./CreateColumnForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateColumnForm.vue?vue&type=style&index=0&id=43d830f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d830f6",
  null
  
)

export default component.exports